<picture class="relative block w-full h-96 bg-white -z-10 -mb-24">
  <img
    class="object-cover opacity-30"
    [ngSrc]="restaurant?.ShowcaseImagePath || defaultImg"
    fill
    priority
    [alt]="restaurant?.TradeName"
  />
</picture>
<div class="max-w-6xl mx-auto px-4 z-50">
  <div class="flex flex-col mx-auto items-center gap-8 justify-center mb-4">
    <img
      class="w-48 h-48 rounded-full border-8 border-white"
      [ngSrc]="restaurant?.LogoImagePath || defaultImg"
      width="192"
      height="192"
      [alt]="restaurant?.TradeName"
    />

    <div class="flex-col justify-start items-center gap-4 flex">
      <div
        class="text-slate-800 text-3xl lg:text-4xl text-center font-medium leading-10"
      >
        {{ restaurant?.TradeName }}
      </div>
      <div class="justify-center items-center gap-2 inline-flex">
        <div class="w-6 h-6 relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 6C11.2583 6 10.5333 6.21993 9.91661 6.63199C9.29993 7.04404 8.81928 7.62971 8.53545 8.31494C8.25162 9.00016 8.17736 9.75416 8.32205 10.4816C8.46675 11.209 8.8239 11.8772 9.34835 12.4017C9.8728 12.9261 10.541 13.2833 11.2684 13.4279C11.9958 13.5726 12.7498 13.4984 13.4351 13.2145C14.1203 12.9307 14.706 12.4501 15.118 11.8334C15.5301 11.2167 15.75 10.4917 15.75 9.75C15.75 8.75544 15.3549 7.80161 14.6517 7.09835C13.9484 6.39509 12.9946 6 12 6ZM12 12C11.555 12 11.12 11.868 10.75 11.6208C10.38 11.3736 10.0916 11.0222 9.92127 10.611C9.75097 10.1999 9.70642 9.7475 9.79323 9.31105C9.88005 8.87459 10.0943 8.47368 10.409 8.15901C10.7237 7.84434 11.1246 7.63005 11.561 7.54323C11.9975 7.45642 12.4499 7.50097 12.861 7.67127C13.2722 7.84157 13.6236 8.12996 13.8708 8.49997C14.118 8.86998 14.25 9.30499 14.25 9.75C14.25 10.3467 14.0129 10.919 13.591 11.341C13.169 11.7629 12.5967 12 12 12ZM12 1.5C9.81273 1.50248 7.71575 2.37247 6.16911 3.91911C4.62247 5.46575 3.75248 7.56273 3.75 9.75C3.75 12.6938 5.11031 15.8138 7.6875 18.7734C8.84552 20.1108 10.1489 21.3151 11.5734 22.3641C11.6995 22.4524 11.8498 22.4998 12.0037 22.4998C12.1577 22.4998 12.308 22.4524 12.4341 22.3641C13.856 21.3147 15.1568 20.1104 16.3125 18.7734C18.8859 15.8138 20.25 12.6938 20.25 9.75C20.2475 7.56273 19.3775 5.46575 17.8309 3.91911C16.2843 2.37247 14.1873 1.50248 12 1.5ZM12 20.8125C10.4503 19.5938 5.25 15.1172 5.25 9.75C5.25 7.95979 5.96116 6.2429 7.22703 4.97703C8.4929 3.71116 10.2098 3 12 3C13.7902 3 15.5071 3.71116 16.773 4.97703C18.0388 6.2429 18.75 7.95979 18.75 9.75C18.75 15.1153 13.5497 19.5938 12 20.8125Z"
              fill="#64748B"
            />
          </svg>
        </div>
        <div
          class="text-justify text-slate-500 text-base font-normal leading-tight tracking-tight"
        >
          {{ restaurant?.Address }}
        </div>
      </div>
    </div>
  </div>

  <div class="w-full flex flex-col mb-16">
    <div class="flex-1 flex flex-col">
      <div class="flex gap-3 mb-6 items-center justify-between">
        <div class="flex gap-3 items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21.75 9C21.7504 8.93027 21.7409 8.86083 21.7219 8.79375L20.3766 4.0875C20.2861 3.77523 20.0971 3.50059 19.8378 3.30459C19.5784 3.10858 19.2626 3.00174 18.9375 3H5.0625C4.73741 3.00174 4.4216 3.10858 4.16223 3.30459C3.90287 3.50059 3.71386 3.77523 3.62344 4.0875L2.27906 8.79375C2.2597 8.86079 2.24991 8.93022 2.25 9V10.5C2.25 11.0822 2.38554 11.6563 2.6459 12.1771C2.90625 12.6978 3.28427 13.1507 3.75 13.5V19.5C3.75 19.8978 3.90804 20.2794 4.18934 20.5607C4.47064 20.842 4.85218 21 5.25 21H18.75C19.1478 21 19.5294 20.842 19.8107 20.5607C20.092 20.2794 20.25 19.8978 20.25 19.5V13.5C20.7157 13.1507 21.0937 12.6978 21.3541 12.1771C21.6145 11.6563 21.75 11.0822 21.75 10.5V9ZM5.0625 4.5H18.9375L20.0081 8.25H3.99469L5.0625 4.5ZM9.75 9.75H14.25V10.5C14.25 11.0967 14.0129 11.669 13.591 12.091C13.169 12.5129 12.5967 12.75 12 12.75C11.4033 12.75 10.831 12.5129 10.409 12.091C9.98705 11.669 9.75 11.0967 9.75 10.5V9.75ZM8.25 9.75V10.5C8.25 11.0967 8.01295 11.669 7.59099 12.091C7.16903 12.5129 6.59674 12.75 6 12.75C5.40326 12.75 4.83097 12.5129 4.40901 12.091C3.98705 11.669 3.75 11.0967 3.75 10.5V9.75H8.25ZM18.75 19.5H5.25V14.175C5.4969 14.2248 5.74813 14.2499 6 14.25C6.58217 14.25 7.15634 14.1145 7.67705 13.8541C8.19776 13.5937 8.6507 13.2157 9 12.75C9.3493 13.2157 9.80224 13.5937 10.323 13.8541C10.8437 14.1145 11.4178 14.25 12 14.25C12.5822 14.25 13.1563 14.1145 13.6771 13.8541C14.1978 13.5937 14.6507 13.2157 15 12.75C15.3493 13.2157 15.8022 13.5937 16.3229 13.8541C16.8437 14.1145 17.4178 14.25 18 14.25C18.2519 14.2499 18.5031 14.2248 18.75 14.175V19.5ZM18 12.75C17.4033 12.75 16.831 12.5129 16.409 12.091C15.9871 11.669 15.75 11.0967 15.75 10.5V9.75H20.25V10.5C20.25 11.0967 20.0129 11.669 19.591 12.091C19.169 12.5129 18.5967 12.75 18 12.75Z"
              fill="#94A3B8"
            />
          </svg>
          <h4 class="text-justify text-slate-800 text-2xl font-medium">
            Sobre
          </h4>
        </div>
        <div class="cursor-pointer" (click)="copyUrl()">
          <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.833 18L16.8916 21.2191M12.0321 14.4292L17.0021 10.8792"
              stroke="#020617"
              stroke-width="1.2"
              stroke-linecap="square"
            />
            <path
              d="M29.1663 15.9999C29.1663 22.6666 23.8635 28.6666 16.4997 28.6666C9.13588 28.6666 3.83301 22.6666 3.83301 15.9999C3.83301 8.63612 9.83301 3.33325 16.4997 3.33325C23.1663 3.33325 29.1663 8.63612 29.1663 15.9999Z"
              stroke="#020617"
              stroke-width="1.2"
            />
            <ellipse
              cx="9.83366"
              cy="15.9999"
              rx="2.66667"
              ry="2.66667"
              stroke="#020617"
              stroke-width="1.2"
              stroke-linecap="round"
            />
            <ellipse
              cx="19.1667"
              cy="9.33342"
              rx="2.66667"
              ry="2.66667"
              stroke="#020617"
              stroke-width="1.2"
              stroke-linecap="round"
            />
            <circle
              cx="19.1667"
              cy="22.6667"
              r="2.66667"
              stroke="#020617"
              stroke-width="1.2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
      <div
        class="text-justify text-slate-500 text-lg font-normal leading-snug tracking-tight"
      >
        {{ restaurant?.Description }}
      </div>
    </div>
  </div>

  <div class="mb-10">
    <mobo-coupon-list
      listTitle="PRINCIPAIS OFERTAS"
      [campaigns]="restaurant?.Campaigns"
      [showButton]="false"
    ></mobo-coupon-list>
  </div>

  <div
    class="w-full h-10 px-4 py-3 bg-slate-100 rounded-lg justify-center items-center gap-1 inline-flex mb-20"
  >
    <div class="w-4 h-4 relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM9 11C9 11.1326 8.94732 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24022 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94732 10.7402 9 10.8674 9 11ZM7 5.25C7 5.10166 7.04399 4.95666 7.1264 4.83332C7.20881 4.70999 7.32595 4.61386 7.46299 4.55709C7.60003 4.50032 7.75083 4.48547 7.89632 4.51441C8.04181 4.54335 8.17544 4.61478 8.28033 4.71967C8.38522 4.82456 8.45665 4.9582 8.48559 5.10368C8.51453 5.24917 8.49968 5.39997 8.44291 5.53701C8.38615 5.67406 8.29002 5.79119 8.16668 5.8736C8.04334 5.95601 7.89834 6 7.75 6C7.55109 6 7.36032 5.92098 7.21967 5.78033C7.07902 5.63968 7 5.44891 7 5.25Z"
          fill="#64748B"
        />
      </svg>
    </div>
    <div class="text-slate-500 text-sm font-normal leading-none tracking-tight">
      As informações disponíveis são de responsabilidade do estabelecimento.
    </div>
  </div>

  <div class="mb-20">
    <mobo-faq></mobo-faq>
  </div>

  <div class="flex flex-col items-center mb-10">
    <div
      class="text-center text-slate-800 text-3xl font-semibold tracking-tight mb-14"
    >
      Principais Lojas
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <p
        class="text-justify text-slate-800 text-md font-medium cursor-pointer truncate hover:text-primary-500"
        *ngFor="let restaurant of webappService.restaurants | async"
        (click)="
          redirectToRestaurant(restaurant.SluggedTradeName, restaurant.Id)
        "
        [title]="restaurant.TradeName"
      >
        {{ restaurant.TradeName }}
      </p>
    </div>
  </div>
</div>
